import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  Inject,
} from "@angular/core";
import { Status } from "@app/models";
import { ALERT_DATA } from "./alert.injector-token";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
})
export class AlertComponent implements OnInit {
  message: string;
  time = 10;

  status: Status = "success";

  @Output() close: EventEmitter<any> = new EventEmitter();

  timeout: any;

  constructor(
    @Inject(ALERT_DATA)
    public data: { disableAutoClose: boolean; hideClose: boolean }
  ) {}

  ngOnInit(): void {
    if(!this.data?.disableAutoClose) this.setCloseTimeout();
  }

  get alertClass(): string {
    return `alert ${this.status}`;
  }

  setCloseTimeout() {
    this.timeout = setTimeout(
      () => this.closeAlert(),
      this.readingTime(this.message)
    );
  }

  closeAlert() {
    this.close.emit();
  }

  readingTime(text = "") {
    const minTime = this.time * 1000;
    const numWords = text.split(" ").length;
    const duration = (numWords / 240) * 100 * 1000;

    return duration < minTime ? minTime : duration;
  }

  @HostListener("mouseenter") onMouseEnter() {
    if(!this.data?.disableAutoClose) clearTimeout(this.timeout);
  }

  @HostListener("mouseleave") onMouseLeave() {
    if(!this.data?.disableAutoClose) this.setCloseTimeout();
  }
}
